export class LeadParams {
    public utm_source: string
    public utm_medium: string
    public utm_campaign: string
}